export default __webpack_public_path__ + "static/media/kpi-icon.c46190e6.svg";